import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import React from 'react'
import PropTypes from 'prop-types'
import Slider from 'react-slick'

type CompareClubsCarouselProps = {
  children: React.ReactNode,
}

const CompareClubsCarousel = ( { children }: CompareClubsCarouselProps ) => {
  const settings = {
    'autoplay': false,
    'infinite': false,
    'dots': false,
    'centerMode': true,
    'className': 'compare-clubs-carousel',
    'arrows': false,
  }

  return (
    <Slider { ...settings }>
      { children }
    </Slider>
  )
}

CompareClubsCarousel.propTypes = {
  'children': PropTypes.any.isRequired,
}

export default CompareClubsCarousel
